
import {defineComponent} from "vue";
import UserForm from "@/components/User/UserForm.vue";
export default defineComponent({
  name: "UserRegistration",
  components: {UserForm}
})

